import * as React from 'react'
import {
  WrappedFieldProps,
  Field,
  GenericField,
  BaseFieldProps
} from 'redux-form'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import ControlWrapper from './ControlWrapper'
import { Omit } from '../../types'

import './DatepickerControl.scss'

export type DatepickerControlCustomProps = Omit<
  ReactDatePickerProps,
  'onChange' | 'value' | 'onBlur' | 'onFocus' | 'name'
>

export type DatepickerControlProps = WrappedFieldProps &
  DatepickerControlCustomProps

export const styles = error => ({
  control: (base, state) => ({
    ...base,
    borderColor: error ? 'red' : base.borderColor
  })
})

const DatepickerControl: React.SFC<DatepickerControlProps> = props => {
  const { input, label, meta, ...rest } = props

  return (
    <ControlWrapper name={input.name} label={label} meta={meta}>
      <DatePicker
        onChange={input.onChange}
        selected={input.value}
        onBlur={() => (input.onBlur as any)()}
        onFocus={() => (input.onFocus as any)()}
        name={input.name}
        {...rest}
      />
    </ControlWrapper>
  )
}

const CustomField = Field as new () => GenericField<
  DatepickerControlCustomProps
>

export type DatepickerControlFieldProps = BaseFieldProps<
  DatepickerControlCustomProps
> &
  DatepickerControlCustomProps

export const DatepickerControlField: React.SFC<
  DatepickerControlFieldProps
> = props => <CustomField {...props} component={DatepickerControl} />

export default DatepickerControl



// WEBPACK FOOTER //
// ./src/components/form/DatepickerControl.tsx